import React from "react";
import { HomeIcon, UserIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { UsersIcon } from "@heroicons/react/24/outline";

const Sidebar = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen">
			<nav className="w-full flex items-center justify-between bg-primary text-white px-6 py-4 shadow fixed top-0 left-0 z-50">
				<div
					className="flex items-center gap-3 cursor-pointer"
					onClick={() => (window.location = "/")}
				>
					<div className="flex items-center gap-3 select-none">
						<div className="flex flex-col leading-tight">
							<div className="flex items-center">
								<img
									src="https://www.vakrangee.in/images/logo.png"
									alt="Your Logo"
								></img>
							</div>
						</div>
					</div>
				</div>

				<h1 className="text-lg font-semibold">
					Welcome to Vakrangee Kendra Management System
				</h1>

				<div className="text-right text-sm">
					<p className="font-semibold">User Name - RJ0104104</p>
					<p>Wallet Balance: 6695127.5</p>
				</div>
			</nav>

			<div className="flex pt-[80px]">
				<aside className="w-20 bg-primary flex flex-col items-center py-8 space-y-8 text-white h-screen fixed left-0 top-[80px]">
					<div className="group">
						<button
							onClick={() => navigate("/")}
							className="
							w-12 h-12 flex items-center justify-center 
							rounded-xl bg-white/10 hover:bg-white/20 
							transition-all duration-200
						"
						>
							<HomeIcon className="w-7 h-7 text-white" />
						</button>
						<div className="absolute left-20 mt-[-40px] opacity-0 group-hover:opacity-100 transition bg-gray-800 text-white text-xs px-2 py-1 rounded">
							Home
						</div>
					</div>
					<div className="group">
						<button
							onClick={() => navigate("/Dashboard/Leads")}
							className="
			w-12 h-12 flex items-center justify-center 
			rounded-xl bg-white/10 hover:bg-white/20 
			transition-all duration-200
		"
						>
							<UsersIcon className="w-7 h-7 text-white" />
						</button>
						<div className="absolute left-20 mt-[-40px] opacity-0 group-hover:opacity-100 transition bg-gray-800 text-white text-xs px-2 py-1 rounded">
							All Leads
						</div>
					</div>

					<div className="group">
						<button
							className="
							w-12 h-12 flex items-center justify-center 
							rounded-xl bg-white/10 hover:bg-white/20 
							transition-all duration-200
						"
						>
							<UserIcon className="w-7 h-7 text-white" />
						</button>
						<div className="absolute left-20 mt-[-40px] opacity-0 group-hover:opacity-100 transition bg-gray-800 text-white text-xs px-2 py-1 rounded">
							Profile
						</div>
					</div>
				</aside>

				<div className="ml-8 p-6 flex-1"></div>
			</div>
		</div>
	);
};

export default Sidebar;
